/**
 * Creates a lookup object that maps the `key` property of each item in `array` to the item itself.
 *
 * @param array - The array to create a lookup for
 * @param key   - The property to use as the key. Defaults to `'id'`
 *
 * @returns A object mapping the `key` property of each item in `array` to the item itself.
 */
export const createLookup = <T extends any>(array: T[], key = 'id'): { [key: string]: T } => (
  array.reduce((lookup, item) => {
    lookup[`${item[key as keyof T]}`] = item;
    return lookup;
  }, {} as { [key: string]: T })
);
